const actionTypes = {
  CLICK: 'click',
  DETAIL: 'detail',
  ADD: 'add',
  REMOVE: 'remove',
  CHECKOUT: 'checkout',
  CHECKOUT_OPTION: 'checkout_option',
  PURCHASE: 'purchase',
  REFUND: 'refund',
  PROMO_CLICK: 'promo_click'
}

const eventAction = {
  VIEW: 'view',
  CLICK: 'click'
}

const eventLabel = {
  ADD_TO_CART: 'add to cart',
  REMOVE_FROM_CART: 'remove from cart',
  CLICK_IN_LISTING: 'click in listing',
  OPTION: 'option'
}

const listTypes = {
  QUICK_ORDER: 'quick Order',
  CART: 'cart',
  GENERAL_CROSS_SELL: 'General cross-sell in main cart',
  RELATED_CROSS_SELL: 'Related cross-sell in main cart',
  SPARE_PARTS_CROSS_SELL: 'Accordion for related products in main cart',
  CHECKOUT_CART: 'Checkout Cart',
  ARTICLE_WATCH: 'Article Watch',
  SEARCH_LISTING: 'Search Listing',
  SEARCH_LISTING_FILTERED: 'Search Listing Filtered'
}

export {
  actionTypes,
  eventAction,
  eventLabel,
  listTypes
}
